import { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { SupportButton } from "@/components/chat/SupportButton";

interface LayoutProps {
  children: ReactNode;
  hideFooterQR?: boolean;
}

export function Layout({ children, hideFooterQR = false }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer hideQR={hideFooterQR} />
      <SupportButton />
    </div>
  );
}
